var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSteuerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H8",
    stroke: "#6281A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H8",
    stroke: "#6281A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H8",
    stroke: "#6281A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.00065C4 2.73543 4.10536 2.48108 4.29289 2.29354C4.48043 2.10601 4.73478 2.00065 5 2.00065C5.24762 1.99929 5.49048 2.06867 5.7 2.20065L6.633 2.80065C6.84204 2.93423 7.08493 3.0052 7.333 3.0052C7.58107 3.0052 7.82396 2.93423 8.033 2.80065L8.967 2.20065C9.17604 2.06707 9.41893 1.99609 9.667 1.99609C9.91507 1.99609 10.158 2.06707 10.367 2.20065L11.3 2.80065C11.509 2.93423 11.7519 3.0052 12 3.0052C12.2481 3.0052 12.491 2.93423 12.7 2.80065L13.633 2.20065C13.842 2.06707 14.0849 1.99609 14.333 1.99609C14.5811 1.99609 14.824 2.06707 15.033 2.20065L15.967 2.80065C16.176 2.93423 16.4189 3.0052 16.667 3.0052C16.9151 3.0052 17.158 2.93423 17.367 2.80065L18.3 2.20065C18.5095 2.06867 18.7524 1.99929 19 2.00065C19.2652 2.00065 19.5196 2.10601 19.7071 2.29354C19.8946 2.48108 20 2.73543 20 3.00065V21.0006C20 21.2659 19.8946 21.5202 19.7071 21.7078C19.5196 21.8953 19.2652 22.0006 19 22.0006C18.7524 22.002 18.5095 21.9326 18.3 21.8006L17.367 21.2006C17.158 21.0671 16.9151 20.9961 16.667 20.9961C16.4189 20.9961 16.176 21.0671 15.967 21.2006L15.033 21.8006C14.824 21.9342 14.5811 22.0052 14.333 22.0052C14.0849 22.0052 13.842 21.9342 13.633 21.8006L12.7 21.2006C12.491 21.0671 12.2481 20.9961 12 20.9961C11.7519 20.9961 11.509 21.0671 11.3 21.2006L10.367 21.8006C10.158 21.9342 9.91507 22.0052 9.667 22.0052C9.41893 22.0052 9.17604 21.9342 8.967 21.8006L8.033 21.2006C7.82396 21.0671 7.58107 20.9961 7.333 20.9961C7.08493 20.9961 6.84204 21.0671 6.633 21.2006L5.7 21.8006C5.49048 21.9326 5.24762 22.002 5 22.0006C4.73478 22.0006 4.48043 21.8953 4.29289 21.7078C4.10536 21.5202 4 21.2659 4 21.0006V3.00065Z",
    stroke: "#6281A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteuerLogo);
export default __webpack_public_path__ + "static/media/steuerLogo.571ef922fc17e1df5c81fce4c49e3e63.svg";
export { ForwardRef as ReactComponent };